import QuoteTable from "../modules/quote_table/index_new"
import delayparams from "../modules/url/delayQuote"
import Param from '../modules/public_fun/param'
import cookie from '../modules/cookie'

let quote_api_host = '//push2.eastmoney.com'

if(Param.get('env') == 'test'){
    quote_api_host = '//push2test.eastmoney.com'
}

declare var MobileSelect
declare var Swiper

let data = {
  newclass: null,
  timer: null,
  pz_size: 20,
  quoteConfig: {
    host: "//push2.eastmoney.com",
    unpPath: "/api/qt/ulist.np/get",
    token: "f057cbcbce2a86e2866ab8877db1d059",
    cPath: "/api/qt/clist/get",
    fs: [
      "m:171+t:1", // 关键期限国债
      "m:171+t:2", // 关键期限美债
    ],
  },
  refresh_time: 10,
  fs_index: "m:171+t:1",
  quote_color_reverse: cookie.get("quote_color_rever") == "1",
  // 初始化
  init: function () {
    let self = this
    window.addEventListener('pageshow', function(event) {
      if(cookie.get("refresh_status") == "1"){
        window.location.reload()
        cookie.set("refresh_status","0")
      }
    })

    self.getData(self.getGlobalBondQuote(), self.bindSwiperData)
    self.table = self.makeQuoteTable()
    self.mobileSelectInit()
    // $(".hsphb-more").on("click", async function () {
    //   try {
    //     let data = await self.table.showMore(20)
    //     self.pz_size += 20
    //     let dataNum = data.data.diff.length
    //     if (self.pz_size > dataNum) {
    //       $(".hsphb-more").html("已经到底了")
    //     }
    //   } catch (error) {
    //     $(".hsphb-more").html("暂无数据")
    //   }
    // })
    $("#tips-config").on("click",function(e){
      e.stopPropagation()
      window.location.href = "/quote/tipsconfig.html"
    })

    $("#title-fixed-container").on("click",function(){
      if(self.fs_index == "m:171+t:1"){
        window.location.href = '/quote/hqlist.html?mt=quanqiuguozhai_globaltips'
      }else if(self.fs_index == "m:171+t:2"){
        window.location.href = '/quote/hqlist.html?mt=quanqiuguozhai_ustips'
      }
    })
    $("#rate-spread-container").on("click",function(){
      window.location.href = "/quote/ratelist.html"
    })
    
    self.autoFix(0)
  },
  getGlobalBondQuote: function () {
    let self = this
    let ids = "171.CN10Y,171.US10Y,1.204001"
    let url = quote_api_host + self.quoteConfig.unpPath + "?fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=" + ids + "&ut=" + self.quoteConfig.token + "&forcect=1"
    return url
  },
  getData: function (url, callback) {
    let self = this
    $.ajax({
      url: url,
      type: "get",
      dataType: "json",
      success: function (data) {
        callback(data, self)
      },
    })
  },
  // 给 Swiper 绑定数据
  bindSwiperData: function (data, self) {
    if (data.rc == 0) {
      let _class = ""
      let _siwper_html = ""

      data.data.diff.forEach((item, index) => {
        if (index == 0) {
          _class = "swiper-slide swiper-slide-active"
        } else if (index == 1) {
          _class = "swiper-slide swiper-slide-next"
        } else {
          _class = "swiper-slide"
        }
        _siwper_html += `<div class="${_class}">
                        <div class="zs-wrap">
                            <a href="/quote/stock/${item.f13}.${item.f12}.html">
                                <p class="tips-title">${item.f14}</p>
                                <p class='${self.getSwiperTipsColor(item.f12 == '204001'?false:self.quote_color_reverse,item)}'>${self.formatNum(item.f2, 0, item.f12 == '204001'?3:4)}</p>
                                <p class='${self.getSwiperTipsColor(item.f12 == '204001'?false:self.quote_color_reverse,item)}'>
                                    <span>${self.formatNum(item.f4, 0,item.f12 == '204001'?3:4)}</span>
                                    <span>${self.formatNum(item.f3, 0, 2, "%")}</span>
                                </p>
                            </a>
                        </div>
                    </div>`
      })
      let rate_spread = self.formatNum(self.formatNum(data.data.diff?.[0]?.f2 - data.data.diff?.[1]?.f2, 0, 4)*100,0,0,"BP")
      $("#globalbond").html(_siwper_html)
      $("#rate-spread").text(rate_spread)
      let swiper = new Swiper(".globalbond-swiper", {
        direction: "horizontal",
        slidesPerGroup: 3,
        slidesPerView: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".go-nuxt",
          prevEl: ".go-pre",
        },
      })
    }
  },
  // Swiper 数据刷新
  refreshSwiperData: function (data, self) {
    let _dom = $("#globalbond").find(".swiper-slide")
    if (data.rc == 0) {
      data.data.diff.forEach((item, index) => {
        _dom[index].innerHTML = `<div class="zs-wrap">
            <a href="/quote/stock/${item.f13}.${item.f12}.html">
                <p>${item.f14}</p>
                <p class='${self.getSwiperTipsColor(item.f12 == '204001'?false:self.quote_color_reverse,item)}'>${self.formatNum(item.f2, 2, item.f12 == '204001'?3:4)}</p>
                <p class='${self.getSwiperTipsColor(item.f12 == '204001'?false:self.quote_color_reverse,item)}'>
                    <span>${self.formatNum(item.f4, item.f12 == '204001'?3:4)}</span>
                    <span>${self.formatNum(item.f3, 2, "", "%")}</span>
                </p>
            </a>
        </div>`
      })
    }
  },
  autoFix: function (val) {
    var scTop = 0 //初始化垂直滚动的距离
    $(".hqzx-usa").css("top", val)

    $(document).off("scroll")
    $(document).on("scroll",function () {
      var banOffTop1 = $("#title-fixed-container").offset().top //获取到距离顶部的垂直距离\
      var banOffTop2 = $("#hsphb").offset().top
      var banOffHeight1 = $("#title-fixed-container").height()
      var banOffHeight2 = $("#tips-country").height()
      if (banOffHeight1 && banOffHeight2) {
        var fixedHeight1 = $(".hqzx-usa").height() + val + 20
        var fixedHeight2 = fixedHeight1 + $("#title-fixed-container").height()
        scTop = $(this).scrollTop() //获取到滚动条拉动的距离
        if (scTop >= banOffTop1) {
          $("#title-fixed-container").addClass("title-fix")
        } else {
          $("#title-fixed-container").removeClass("title-fix")
        }
        if (scTop >= banOffTop2 - banOffHeight1 - banOffHeight2 - 10 && $("#hsphb").find("div")[0]) {
          $("#hsphb").find("div")[0].classList.add("table-title-fix")
          $("#hsphb").children("div")[0].style.top = fixedHeight2 - 25 + "px"
          $("#title-fixed-container").addClass("table-title-fix-new")
          $("#hsphb").children("div")[1].style.marginTop = "7rem"
        } else if (scTop < banOffTop2 - banOffHeight1 - banOffHeight2 - 10 && $("#hsphb").find("div")[0]) {
          $("#hsphb").find("div")[0].classList.remove("table-title-fix")
          $("#title-fixed-container").removeClass("table-title-fix-new")
          $("#hsphb").children("div")[1].style.marginTop = "0"
        }
      }
    })
  },
  makeQuoteTable: function () {
    let self = this
    let quotetable = new QuoteTable({
      ele: "hsphb",
      api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&np=1&ut=8a086bfc3570bdde64a6a1c585cccb35&fltt=1&invt=1&fs=${self.fs_index}&fields=f1,f2,f3,f4,f12,f13,f14,f15,f16,f17,f18,f31,f32,f124,f152,f277,f486,f487${delayparams}`,
      params: {
        // 默认参数配置
        // sortkey: "f3",
        sortval: "1",
        size: "20",
      },
      right_tds: 3,
      refresh: 15,
      sortdesc: "1",
      sortasc: "0",
      keyword: "tips",
      item: [
        {
          name: "name",
          title: "名称",
          html: function (data) {
            if (data == null) {
              return `<th>${this.title}</th>`
            } else {
              return `<td><p>${data.f14}</p><p>${data.f12}</p></td>`
            }
          },
          sort: false,
        },
        {
          name: "zx",
          title: "最新",
          html: function (data) {
            if (data == null) {
              return `<th value="true" class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${self.getTipsColor(self.quote_color_reverse,data)}">${self.formatNum(data.f277, data.f1, 4)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f2",
          },
        },
        {
          name: "zdf",
          title: "涨幅",
          html: function (data) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${self.getTipsColor(self.quote_color_reverse,data)}">${self.formatNum(data.f3, data.f152, data.f152, "%")}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "0",
            ascvalue: "1",
            key: "f3",
          },
        },
        {
          name: "zfe",
          title: "涨跌",
          html: function (data) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${self.getTipsColor(self.quote_color_reverse,data)}">${self.formatNum(data.f4, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "0",
            ascvalue: "1",
            key: "f4",
          },
        },
        {
          name: "buy",
          title: "最优报买",
          html: function (data) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${self.getTipsCompareColor(self.quote_color_reverse,data.f31,data.f18)}">${self.formatNum(data.f31, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f31",
          },
        },
        {
          name: "sell",
          title: "最优报卖",
          html: function (data) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${self.getTipsCompareColor(self.quote_color_reverse,data.f32,data.f18)}">${self.formatNum(data.f32, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f32",
          },
        },
        {
          name: "jk",
          title: "今开",
          html: function (data) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${self.getTipsCompareColor(self.quote_color_reverse,data.f17,data.f18)}">${self.formatNum(data.f17, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f17",
          },
        },
        {
          name: "zg",
          title: "最高",
          html: function (data) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${self.getTipsCompareColor(self.quote_color_reverse,data.f15,data.f18)}">${self.formatNum(data.f15, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f15",
          },
        },
        {
          name: "zd",
          title: "最低",
          html: function (data) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td class="${self.getTipsCompareColor(self.quote_color_reverse,data.f16,data.f18)}">${self.formatNum(data.f16, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f16",
          },
        },
        {
          name: "zs",
          title: "昨收",
          html: function (data) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td>${self.formatNum(data.f18, data.f1, data.f1)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f18",
          },
        },
        {
          name: "update",
          title: "更新时间",
          html: function (data) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td>${self.formatDate(data.f124*1000,"hh:mm:ss")}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f124",
          },
        },
        {
          name: "country",
          title: "国家/地区",
          html: function (data) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td>${self.formatCountry(data.f486)}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f486",
          },
        },
        {
          name: "year",
          title: "期限",
          html: function (data) {
            if (data == null) {
              return `<th class="sort_normal">${this.title}</th>`
            } else {
              return `<td>${data.f487}</td>`
            }
          },
          sort: true,
          sortitem: {
            desvalue: "1",
            ascvalue: "0",
            key: "f487",
          },
        },
      ],
    })
    quotetable.init()
    return quotetable
  },
  mobileSelectInit: function () {
    var self = this
    $("#tips-cn").on("click",function(){
      self.fs_index = self.quoteConfig.fs[0]
      $("#tips-cn").addClass("tips-type-active")
      $("#tips-us").removeClass("tips-type-active")
      self.table.destroy()
      // 重新生成列表
      self.table = self.makeQuoteTable()
    })
    $("#tips-us").on("click",function(){
      self.fs_index = self.quoteConfig.fs[1]
      $("#tips-us").addClass("tips-type-active")
      $("#tips-cn").removeClass("tips-type-active")
      self.table.destroy()
      self.table = self.makeQuoteTable()
    })
  },
  formatZS(num: number, isSign: boolean) {
    let numSign: string
    let self = this
    if (isSign) {
      if (num < 0) {
        numSign = "-"
      } else if (num == 0) {
        numSign = ""
      } else {
        numSign = ""
      }
    } else {
      numSign = ""
    }
    if (Math.abs(num) == 0) {
      return 0
    } else if (Math.abs(num) > 0 && Math.abs(num) < 100000) {
      return numSign + self.formatNum(Math.abs(num), 0, 0)
    } else if (Math.abs(num) >= 100000 && Math.abs(num) < 1000000) {
      return numSign + self.formatNum(Math.abs(num) / 10000, 0, 1, "万")
    } else if (Math.abs(num) >= 1000000) {
      return numSign + self.formatNum(Math.abs(num) / 10000, 0, 0, "万")
    } else {
      return "-"
    }
  },
  formatAmount(num: number, isSign: boolean) {
    let numSign: string
    let self = this
    if (isSign) {
      if (num < 0) {
        numSign = "-"
      } else if (num == 0) {
        numSign = ""
      } else {
        numSign = ""
      }
    } else {
      numSign = ""
    }
    if (Math.abs(num) == 0) {
      return 0
    } else if (Math.abs(num) > 0 && Math.abs(num) < 100000) {
      return numSign + self.formatNum(Math.abs(num), 0, 0)
    } else if (Math.abs(num) >= 100000 && Math.abs(num) < 100000000) {
      return numSign + self.formatNum(Math.abs(num) / 10000, 0, 0, "万")
    } else if (Math.abs(num) >= 100000000) {
      return numSign + self.formatNum(Math.abs(num) / 100000000, 0, 2, "亿")
    } else {
      return "-"
    }
  },
  formatNum(value: any, rate: number, tofixed: number, suffix = "") {
    if (value == "-" || value == undefined || isNaN(value)) return "-"
    let num = Number(value)
    let r = Number(rate)
    let temp = Math.pow(10, r)

    if (num) {
      return (num / temp).toFixed(tofixed) + suffix
    } else {
      return num.toFixed(tofixed) + suffix
    }
  },
  formatDate(thisdate: any, format: any) {
    if(thisdate == null || thisdate == "-" || isNaN(thisdate)){
      return "-"
    }
    thisdate = new Date(thisdate)
    let o: any = {
      "M+": thisdate.getMonth() + 1, //month
      "d+": thisdate.getDate(), //day
      "h+": thisdate.getHours(), //hour
      "m+": thisdate.getMinutes(), //minute
      "s+": thisdate.getSeconds(), //second
      "q+": Math.floor((thisdate.getMonth() + 3) / 3), //quarter
      S: thisdate.getMilliseconds(), //millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (thisdate.getFullYear() + "").substring(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substring(("" + o[k]).length))
      }
    }
    return format
  },
  formatCountry(value:any){
    if(value == null || value == "-"){
      return "-"
    }
    if(value.toLowerCase() == "cn"){
      return "中国"
    }else if(value.toLowerCase() == "us"){
      return "美国"
    }else{
      return "-"
    }
  },
  getTipsColor(reverse:boolean,data:any){
    if(reverse){
        return data.f4 < 0 ? "shares-rise" : data.f4 > 0 ? "shares-fall" : ""
    }else{
        return data.f4 > 0 ? "shares-rise" : data.f4 < 0 ? "shares-fall" : ""
    }
  },
  getSwiperTipsColor(reverse:boolean,data:any){
    if(reverse){
        return data.f4 < 0 ? "gp-asc" : data.f4 > 0 ? "gp-des" : ""
    }else{
        return data.f4 > 0 ? "gp-asc" : data.f4 < 0 ? "gp-des" : ""
    }
  },
  getTipsCompareColor(reverse:boolean, value: any, value1: any) {
    if (value == null || value == "-" || value1 == null || value1 == "-") {
      return ""
    }
  
    if (value.toString() == "0" || value.toString() == "0.0" || value.toString() == "0.00" || value.toString() == "0.000" || value.toString() == "0.0000") {
      return ""
    }
  
    if(reverse){
      if (parseFloat(value) < parseFloat(value1)) {
        return "shares-rise"
      } else if (parseFloat(value) > parseFloat(value1)) {
        return "shares-fall"
      } else if (parseFloat(value) == parseFloat(value1)) {
        return ""
      }
    }else{
      if (parseFloat(value) > parseFloat(value1)) {
        return "shares-rise"
      } else if (parseFloat(value) < parseFloat(value1)) {
        return "shares-fall"
      } else if (parseFloat(value) == parseFloat(value1)) {
        return ""
      }
    }
  },
}

data.init()

import { NavScroll } from "../modules/title_scroll"
NavScroll("nav_tips")
